<div class="tabular-mapping-container">
    <div class="columns-mapping-container">
        <app-arbor-processing-card 
            mainText="Arbor.ia analisando e mapeando colunas" 
            subText="Detectando nomes, tipos e correspondências"
            *ngIf="isLoading()"
        ></app-arbor-processing-card>
        <ul *ngIf="!isLoading()">
            <li>
                <span class="label-title">Nome Original</span> 
                <span class="label-title">Nome Exibido</span> 
                <span class="label-title">Tipo</span>
            </li>
            <li *ngFor="let col of displayColumns(); let i = index; trackBy: trackByColumnIndex;">
                <span>{{serviceColumns()[i].name}}</span>
                <input 
                    type="text" 
                    class="search-input alias-input-dimension" 
                    [disabled]="!isMappingStep || isFinishing()"
                    [ngModel]="col.name"
                    (ngModelChange)="onColumnNameChange($event, col, i)"
                >
                <app-single-select
                    [options]="typeOptions"
                    valueKey="value"
                    labelKey="label"
                    [hasSearch]="false"
                    [initialValue]="col.type"
                    [disabled]="!isMappingStep || isFinishing()"
                    (selectionChange)="onSelectionChange($event, i)"
                ></app-single-select>
            </li>
        </ul>
        <app-observation-card 
            variant="info"
            message="Os nomes e tipos acima foram inferidos a partir dos dados da tabela pelo Arbor.ia, altere-os conforme necessário"
            *ngIf="!isLoading()"
        ></app-observation-card>
    </div>
    
    <div class="preview-tabular-container">
        <mat-progress-bar 
        class="pending-list-progress-bar" 
        mode="determinate" 
        [value]="loadingProgress()"
        *ngIf="isFinishing()"
        ></mat-progress-bar>

        <cdk-virtual-scroll-viewport class="table-wrapper" [itemSize]="52" [maxBufferPx]="1200" [minBufferPx]="400">
            <table mat-table [dataSource]="tabularTableDataSource()" *ngIf="!isLoading()">
                <ng-container *ngFor="let column of columns_names(); let i = index; trackBy: trackByColumnName">
                    <ng-container [matColumnDef]="column">
                        <th mat-header-cell *matHeaderCellDef> {{ importWizardStorage.display_columns_names()[i] }} </th>
                        <td mat-cell *matCellDef="let row">
                            {{ row[column] == "" ? '--' : row[column] }}
                        </td>
                    </ng-container>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="columns_names(); sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: columns_names()"></tr>
            </table>
        </cdk-virtual-scroll-viewport>
    </div>
</div>

<div class="button-container">
    <button 
    class="secondary" 
    [disabled]="isFinishing() || isLoading()" 
    (click)="handleCancelClick()"
    > 
        Descartar Importação 
    </button>
    <button 
    class="primary" 
    [disabled]="isFinishing() || isLoading()" 
    [innerText]="buttonLabel()" 
    (click)="handleButtonClick()"
    ></button>
</div>

<app-alert 
    title="Cancelar importação"
    message="Deseja realmente cancelar essa importação? Todo o progresso será perdido."
    confirmText="Confirmar"
    cancelText="Voltar"
    [visible]="isAlertVisible"
    (onConfirmEvent)="handleCancelClickConfirmation()"
    (onCancelEvent)="handleCancelClickCancel()"
></app-alert>